import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocketsManager = _resolveComponent("SocketsManager")!
  const _component_ToastrsManager = _resolveComponent("ToastrsManager")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!
  const _component_KC = _resolveComponent("KC")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_SocketsManager),
          _createVNode(_component_ToastrsManager),
          _createVNode(_component_ModalConfirm),
          _createVNode(_component_KC),
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}